module.exports = __webpack_public_path__ + "media/src/images/dandori/step-complete-dfe31df8cfab826ea2fe995377f8f34a.png";